export const macroSearchText = macro =>
  [
    macro.name,
    ...(macro.actions ?? []).map(action =>
      JSON.stringify(action.action_params ?? '')
    ),
  ]
    .join(' ')
    .toLocaleLowerCase();

export const filterMacros = (macros, query) => {
  const normalizedQuery = query.trim().toLocaleLowerCase();

  return normalizedQuery
    ? macros.filter(macro => macroSearchText(macro).includes(normalizedQuery))
    : [...macros];
};
